import * as billingMain from './billing-main.js';
import * as billingCentre from './billingCentre.js';
import * as controlLevel from './controlLevel.js';
import * as sage from './sage.js';
import * as billingKeepRate from './billing-keeprate.js';
import * as billingExport from './billing-export.js';
import * as invoiceMain from './invoice-main.js';
import * as invoiceReviewCriteria from './invoice-review-criteria.js';
import * as invoiceEmailReview from './invoice-email-review.js';

export default {
    billingMain,
    billingCentre,
    controlLevel,
    sage,
    billingKeepRate,
    billingExport,
    invoiceMain,
    invoiceReviewCriteria,
    invoiceEmailReview,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Billing Main
    window.EQLAPP.BILLING = window.EQLAPP.BILLING || {};
    Object.entries(billingMain).forEach(([key, value]) => {
        window.EQLAPP.BILLING[key] = value;
    });

    // Billing Centre
    window.EQLAPP.BILLINGCENTRE = window.EQLAPP.BILLINGCENTRE || {};
    Object.entries(billingCentre).forEach(([key, value]) => {
        window.EQLAPP.BILLINGCENTRE[key] = value;
    });

    // Control Level
    window.EQLAPP.CONTROLLEVEL = window.EQLAPP.CONTROLLEVEL || {};
    Object.entries(controlLevel).forEach(([key, value]) => {
        window.EQLAPP.CONTROLLEVEL[key] = value;
    });

    // Sage
    window.EQLAPP.SAGE = window.EQLAPP.SAGE || {};
    Object.entries(sage).forEach(([key, value]) => {
        window.EQLAPP.SAGE[key] = value;
    });

    // Billing Keep Rate
    window.EQLAPP.KEEPRATE = window.EQLAPP.KEEPRATE || {};
    Object.entries(billingKeepRate).forEach(([key, value]) => {
        window.EQLAPP.KEEPRATE[key] = value;
    });

    // Billing Exports
    window.EQLAPP.BILLINGEXPORT = window.EQLAPP.BILLINGEXPORT || {};
    Object.entries(billingExport).forEach(([key, value]) => {
        window.EQLAPP.BILLINGEXPORT[key] = value;
    });

    // Invoice Main (shared zip queue and print-options report submit)
    window.EQLAPP.INVOICEMAIN = window.EQLAPP.INVOICEMAIN || {};
    Object.entries(invoiceMain).forEach(([key, value]) => {
        window.EQLAPP.INVOICEMAIN[key] = value;
    });

    // Invoice Review criteria page (billing_email_invoices)
    window.EQLAPP.INVOICEREVIEW = window.EQLAPP.INVOICEREVIEW || {};
    Object.entries(invoiceReviewCriteria).forEach(([key, value]) => {
        window.EQLAPP.INVOICEREVIEW[key] = value;
    });

    // Invoice email review grid (billing_invoice_email)
    window.EQLAPP.INVOICEEMAILREVIEW = window.EQLAPP.INVOICEEMAILREVIEW || {};
    Object.entries(invoiceEmailReview).forEach(([key, value]) => {
        window.EQLAPP.INVOICEEMAILREVIEW[key] = value;
    });

}